import React from 'react'
import Helmet from 'react-helmet'
import Icon from '../../components/Icon'
import Checkbox from '../../components/Checkbox'
import Button from '../../components/Button'
import Link from '../../components/Link'
import NewsletterCollection from '../../components/NewsletterCollection'
import PageSection from '../../components/PageSection'

import { trackEvent } from '../../../utils/tracking'

const SHARE_DESCRIPTION = `Snips AI is private by design.
This means we never get access to your data, so we are asking for contributions of anonymized messages.
In return, you get an interactive visualization of your texting style. :)`

const CtaButton = ({ position, primaryClass }) => (
  <Button
    className={`emotional-snapshot-page__cta-button button ${primaryClass} button--large`}
    href='/downloads/Emotional Snapshot.zip'
    download
    onClick={() => trackEvent(`EmotionalSnapshotDownloadButton-${position}`)}
  >
    <Icon icon='apple' /> Download for Mac
  </Button>
)

export const EmotionalSnapshotPage = () => (
  <main className='center'>
    {/* NOTE: Helmet lib content goes into <head> tags */}
    <Helmet
      meta={[
        { property: 'og:description', content: SHARE_DESCRIPTION },
        { property: 'description', content: SHARE_DESCRIPTION },
        { property: 'twitter:card', content: undefined },
        { property: 'twitter:card', content: 'summary_large_image' },
        {
          property: 'og:image',
          content:
            'https://snips.ai/static/images/Emotional-Snapshot-share-image-2.png'
        },
        { property: 'og:image:width', content: '1738' },
        { property: 'og:image:height', content: '915' }
      ]}
    />
    <PageSection first extraClass='emotional-snapshot-page__hero-section'>
      <div className='emotional-snapshot-page__hero-content'>
        <div
          className='emotional-snapshot-page__hero-media'
          title='Contribute and get an emotional analysis of your conversations!'
        >
          <img
            className='emotional-snapshot-page__hero-media-img emotional-snapshot-page__hero-media-img--first'
            alt='An example of an Emotional Snapshot'
            src='/static/images/seeds/example-emotion-dataviz-3.png'
          />
          <img
            className='emotional-snapshot-page__hero-media-img emotional-snapshot-page__hero-media-img--second'
            alt='An example of an Emotional Snapshot'
            src='/static/images/seeds/example-emotion-dataviz-you.png'
          />
        </div>
        <div className='emotional-snapshot-page__hero-body'>
          <h1 className='h2 emotional-snapshot-page__title mb2'>
            An emotional snapshot of your texting style
          </h1>
          <p className='text-para mb3'>
            Snips AI is private by design. This means we never get access to
            your data, so we are asking for contributions of anonymized messages
            instead. In return, you get an interactive visualization of your
            texting style. :) Any questions? Ask our CEO directly. <br />🤖🤓{' '}
            <Link target='_blank' href='https://twitter.com/randhindi'>
              @RandHindi
            </Link>
          </p>
          <div className='blue flex strong'>
            <Icon icon='apple' className='icon icon--blue mr2' />Compatible with
            iPhone only
          </div>
        </div>
      </div>
    </PageSection>

    <PageSection
      quilt
      extraClass='white emotional-snapshot-page__features-section'
      beforeSection={
        <CtaButton
          position='Top'
          primaryClass='button--primary emotional-snapshot-page__between-sections-button'
        />
      }
    >
      <h2 className='h2 emotional-snapshot-page__features-title'>
        How it works
      </h2>

      <div className='emotional-snapshot-page__feature'>
        <Icon
          className='icon emotional-snapshot-page__feature-icon'
          icon='phone-messages'
        />
        Extract messages from your phone
      </div>

      <div className='emotional-snapshot-page__feature'>
        <Icon
          className='icon emotional-snapshot-page__feature-icon'
          icon='checkbox-lock'
        />
        Filter conversations you don’t want to contribute in your soon-to-be
        anonymous data contribution
      </div>

      <div className='emotional-snapshot-page__feature'>
        <Icon
          className='icon emotional-snapshot-page__feature-icon'
          icon='anonymize-send'
        />
        Anonymize &amp; send!<br />
        Take a look at your personal emotional snapshot
      </div>
    </PageSection>

    <PageSection extraClass='page-section--tiny bg-light-grey'>
      <p>Get access to the latest AI tech</p>
      <div className='col-12 sm-col-10 md-col-6 mx-auto'>
        <NewsletterCollection
          label=''
          trackingContext='EmotionalSnapshotMidPage'
        />
      </div>
    </PageSection>

    <PageSection>
      <div className='col-10 md-col-12 maxw-large mx-auto'>
        <h2 className='h2 emotional-snapshot-page__features-title'>
          What you need
        </h2>
        <div className='lg-flex items-center mb4'>
          <ul className='px2 flex items-center justify-between emotional-snapshot-page__requirements-icons'>
            <div>
              <li className='center emotional-snapshot-page__requirements-icon emotional-snapshot-page__requirements-icon--mac'>
                <Icon icon='apple-mac' />
              </li>
            </div>
            <div>
              <li className='center emotional-snapshot-page__requirements-icon emotional-snapshot-page__requirements-icon--phone'>
                <Icon icon='apple-iphone' />
              </li>
            </div>
            <div>
              <li className='center emotional-snapshot-page__requirements-icon emotional-snapshot-page__requirements-icon--apps'>
                <Icon className='icon mb2' icon='imessage' />
                <br />
                <Icon icon='whatsapp' />
              </li>
            </div>
          </ul>

          <div>
            <ul className='left-align px2 h3'>
              {[
                'Mac',
                'iPhone',
                'iMessage and/or Whatsapp'
              ].map((label, idx) => (
                <li key={idx} className='py2'>
                  <Checkbox checked /> {label}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className='py2 center'>
          <CtaButton position='Bottom' primaryClass='button--primary-alt' />
        </div>
      </div>
    </PageSection>
  </main>
)

export default EmotionalSnapshotPage



// WEBPACK FOOTER //
// ./frontend/scripts/react/pages/seeds/EmotionalSnapshotPage.js